import enTranslations from './translations/en.json';
import hiTranslations from './translations/hi.json';

const translations = {
  en: enTranslations,
  hi: hiTranslations
};

const defaultLanguage = 'en';
const supportedLanguages = ['en', 'hi'];

class I18n {
  constructor() {
    this.currentLanguage = this.getStoredLanguage() || defaultLanguage;
  }

  getStoredLanguage() {
    try {
      return localStorage.getItem('app_language') || defaultLanguage;
    } catch (error) {
      return defaultLanguage;
    }
  }

  setLanguage(language) {
    if (supportedLanguages.includes(language)) {
      this.currentLanguage = language;
      localStorage.setItem('app_language', language);
      // Trigger language change event
      window.dispatchEvent(new CustomEvent('languageChanged', { detail: { language } }));
    }
  }

  getLanguage() {
    return this.currentLanguage;
  }

  t(key, params = {}) {
    const keys = key.split('.');
    let value = translations[this.currentLanguage];

    for (const k of keys) {
      if (value && typeof value === 'object') {
        value = value[k];
      } else {
        // Fallback to English if translation not found
        value = translations[defaultLanguage];
        for (const fallbackKey of keys) {
          if (value && typeof value === 'object') {
            value = value[fallbackKey];
          } else {
            return key; // Return key if translation not found
          }
        }
        break;
      }
    }

    if (typeof value !== 'string') {
      return key;
    }

    // Replace parameters in translation
    if (params && Object.keys(params).length > 0) {
      return value.replace(/\{\{(\w+)\}\}/g, (match, paramKey) => {
        return params[paramKey] !== undefined ? params[paramKey] : match;
      });
    }

    return value;
  }

  getSupportedLanguages() {
    return supportedLanguages;
  }

  getLanguageName(code) {
    const names = {
      en: 'English',
      hi: 'Hindi'
    };
    return names[code] || code;
  }
}

export const i18n = new I18n();
export default i18n;

